import { acfModules } from 'root/main/components/acfModules/';
import { dropdownFilter } from 'root/main/components/dropdownFilter/';
import { regionAlert } from 'root/main/components/regionAlert/';
import { mediaLightbox } from 'root/main/components/mediaLightbox/';
import { navigation } from 'root/main/components/navigation/';
import { accordion } from 'root/main/components/accordion/';
import { dialog } from 'root/main/components/dialog/';
import { emailPreferenceCenter } from 'root/main/components/emailPreferenceCenter/';
import { delayVideoLoad } from 'root/main/components/delayVideoLoad/';
import { forms, lightboxHandler } from 'root/main/components/forms/';
import { section179Calculator } from 'root/main/components/section179Calculator/';
import { setBlogSubscriptionCookie } from 'root/main/components/setBlogSubscriptionCookie/';
import {
    alertBanner,
    alertPopup,
    cookieNotificationBanner,
} from 'root/main/components/alertBanner/';
import { menuTemplate } from 'root/main/components/menuTemplate/';
import { barcodeGenerator } from 'root/main/components/barcodeGenerator/';
import { events } from 'root/main/components/events/';
import { wizard } from 'root/main/components/wizard/';
import { wizardForm } from 'root/main/components/wizardForm/';
import { tooltip } from 'root/main/components/tooltip/';
import { tablist } from 'root/main/components/tablist';
import { animatedTabSection } from 'root/main/components/animatedTabSection';
import { careersTestimonials } from 'root/main/components/careersTestimonials/';
import { languageSelector } from 'root/main/components/languageSelector';
import { careersJobFilter } from 'root/main/components/careersJobFilter/';
import { featurePricingModule } from 'root/main/components/featurePricingModule';
import { supplierCatalog } from 'root/main/components/supplierCatalog';
import { regionalLogos } from 'root/main/components/regionalLogos';
import { parallaxCarouselModule } from 'root/main/components/parallaxCarouselModule';
import { clickwrapContractPage } from 'root/main/components/clickwrapContractPage';
import { animations, preventAnimationsAboveFold } from 'root/main/components/animations';
import { comparisonTableTabs } from 'root/main/components/comparisonTableTabs';
import { threeChannelContactPage } from 'root/main/components/threeChannelContactPage';
import { hardwareSPA } from 'root/main/components/hardwareSPA';
import { videoEmbed } from 'root/main/components/videoEmbed';

const defaultComponentMap = [
    { navigation },
    { preventAnimationsAboveFold },
    { acfModules },
    { dropdownFilter },
    { setBlogSubscriptionCookie },
    { cookieNotificationBanner },
    { mediaLightbox },
    { accordion },
    { dialog },
    { forms },
    { events },
    { careersJobFilter },
    { featurePricingModule },
    { supplierCatalog },
    { regionalLogos },
    { parallaxCarouselModule },
    { clickwrapContractPage },
    { comparisonTableTabs },
    { threeChannelContactPage },
    { hardwareSPA },
];

const onLoadComponentMap = [
    { animations },
    { emailPreferenceCenter },
    { delayVideoLoad },
    { section179Calculator },
    { alertBanner },
    { alertPopup }, // the alert popup needs to be always loaded before the region alert
    { regionAlert }, // the region alert needs to be always loaded after the alert popup
    { menuTemplate },
    { barcodeGenerator },
    { wizard },
    { wizardForm },
    { tooltip },
    { tablist },
    { animatedTabSection },
    { careersTestimonials },
    { languageSelector },
    { videoEmbed },
];

const onClickComponentsCallbacks = [lightboxHandler];

export { defaultComponentMap, onLoadComponentMap, onClickComponentsCallbacks };
